import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/lastfm-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM307.8 344.9C244.4 344.9 222.4 316.3 210.7 280.8 194.4 229.8 189.2 196.5 147.7 196.5 125.3 196.5 102.6 212.6 102.6 257.7 102.6 292.9 120.6 314.9 145.9 314.9 174.5 314.9 193.5 293.6 193.5 293.6L205.2 325.5S185.4 344.9 144 344.9C92.7 344.9 64.1 314.8 64.1 259.1 64.1 201.2 92.7 167.1 146.6 167.1 220.1 167.1 227.4 208.5 247.4 269 256.2 295.8 271.6 315.2 308.6 315.2 333.5 315.2 346.7 309.7 346.7 296.1 346.7 276.2 324.9 274.1 296.8 267.5 266.4 260.2 254.3 244.4 254.3 219.5 254.3 179.5 286.6 167.1 319.5 167.1 356.9 167.1 379.6 180.7 382.5 213.7L345.8 218.1C344.3 202.3 334.8 195.7 317.2 195.7 301.1 195.7 291.2 203 291.2 215.5 291.2 226.5 296 233.1 312.1 236.8 344.8 243.9 383.9 248.8 383.9 294.3 384 331 353.2 344.9 307.8 344.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/lastfm-square.js
// module id = KnYA
// module chunks = 144